import React from 'react';
import Icon from './Icon';

const TABS = [
  { id: 'discover', label: 'Discover', icon: 'flame' },
  { id: 'messages', label: 'Messages', icon: 'chat' },
  { id: 'profile', label: 'Profile', icon: 'user' },
];

export default function BottomNav({ active, onChange }) {
  return (
    <nav className="bottom-nav" aria-label="Main navigation">
      <div className="bottom-nav-inner">
        {TABS.map((tab) => {
          const isActive = active === tab.id;
          return (
            <button
              key={tab.id}
              type="button"
              className={`nav-item${isActive ? ' active' : ''}`}
              onClick={() => onChange(tab.id)}
              aria-current={isActive ? 'page' : undefined}
            >
              <Icon name={tab.icon} size={22} strokeWidth={isActive ? 2.3 : 1.8} />
              <span>{tab.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
